import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=035d6b75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035d6b75"]])

export default __exports__